// 统一处理枚举类型
export default function(list, type) {
  let enums = [...list];
  if (type) {
    enums = enums.filter(i => i.types && i.types.includes(type));
  }
  const values = enums.map(item => item.value);
  const keys = enums.map(item => item.key);
  const colors = enums.map(item => item.color);
  return {
    values,
    keys,
    enums,
    colors,
    getKeyByValue(value) {
      return values.indexOf(value) > -1 ? keys[values.indexOf(value)] : '-';
    },
    getValueByKey(key) {
      const index = keys.findIndex(k => String(k) === String(key));
      return index > -1 ? values[index] : '-';
    },
    getColorByKey(key) {
      const index = keys.findIndex(k => String(k) === String(key));
      return index > -1 ? colors[index] : '-';
    }
  };
}
